import { ITotalAmount } from '../../../../../types/reducers/checkoutInfo';
import { formatMoney, formatAuctionPoints } from '../../../../../utils/string';

export const getTotalValue = (totalAmount: ITotalAmount): string => {
  const { price, auctionPoints } = totalAmount;

  return [formatMoney(price), auctionPoints && formatAuctionPoints(auctionPoints)].filter(Boolean).join(' и ');
};
